// extracted by mini-css-extract-plugin
module.exports = {"grid":"pricing-cards_grid__LVS_r"};